export default __webpack_public_path__ + "static/media/Venturer's Boots of Crouching Calm.bb85a136.jpg";